angular.module('gym.reports').factory('SendEmailVerificationService', ["$rootScope", "$stateParams", "$timeout", "$http", "flash", function($rootScope, $stateParams, $timeout, $http, flash) {
  return {
    sendVerificationRequest: function(params, modalInstance) {
      var url;
      url = `/gyms/${$rootScope.gym.id}/email_verifications/send_verification_request`;
      return $http.post(url, params).then(function() {
        modalInstance.close();
        return flash.success = `${params.ids.length} email(s) sent.`;
      });
    },
    close: function(modalInstance) {
      return modalInstance.dismiss('cancel');
    }
  };
}]);
